import { useEffect, useState } from 'react';
import { Link, Navigate, useParams } from 'react-router-dom';
import api from '../api/client';
import { useAuth } from '../context/AuthContext';
import KonspektTiptapView from '../components/KonspektTiptapView';

function audienceRu(a) {
  if (a === 'platform') return 'Для всех на сайте';
  if (a === 'teacher_students') return 'Для учеников преподавателя';
  if (a === 'personal') return 'Личный (ученик и преподаватели)';
  return a;
}

/** Старые URL серии траекторий (ЕГЭ-23 → ЕГЭ-13). */
function redirectSlugFromEge23(slug) {
  if (typeof slug === 'string' && slug.startsWith('ege23-')) {
    return `ege13-${slug.slice('ege23-'.length)}`;
  }
  return null;
}

export default function KonspektDetailPage() {
  const { slug } = useParams();
  const { user } = useAuth();
  const [k, setK] = useState(null);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState('');

  const redirected = redirectSlugFromEge23(slug);

  useEffect(() => {
    if (redirected) return undefined;
    let cancelled = false;
    (async () => {
      setLoading(true);
      setErr('');
      try {
        const { data } = await api.get(`/materials/konspekty/${encodeURIComponent(slug)}/`);
        if (!cancelled) setK(data);
      } catch (e) {
        if (!cancelled) {
          if (e.response?.status === 404) setErr('Конспект не найден или недоступен.');
          else setErr(e.response?.data?.detail || 'Ошибка загрузки');
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [slug, redirected]);

  if (redirected) {
    return <Navigate to={`/konspekty/${encodeURIComponent(redirected)}`} replace />;
  }

  const isAuthor = user && k && user.id === k.author;

  if (loading) {
    return (
      <div className="page">
        <p className="muted">Загрузка…</p>
      </div>
    );
  }

  if (err || !k) {
    return (
      <div className="page">
        <p className="form-error">{err || 'Нет данных'}</p>
        <Link to="/konspekty">К списку</Link>
      </div>
    );
  }

  const doc = k.content?.tiptap;

  return (
    <div className="page konspekt-detail-page">
      <div className="konspekt-detail-head">
        <Link to="/konspekty" className="konspekt-back">
          ← Все конспекты
        </Link>
        <h1>{k.title}</h1>
        <p className="konspekt-detail-meta muted">
          {audienceRu(k.audience)}
          {k.author_username && ` · ${k.author_username}`}
          {` · просмотров: ${k.views_count ?? 0}`}
        </p>
        {k.tags?.length > 0 && (
          <div className="konspekt-tags">
            {k.tags.map((t) => (
              <span key={t.id} className="konspekt-tag-pill">
                {t.name}
              </span>
            ))}
          </div>
        )}
        {isAuthor && (
          <Link to={`/konspekty/${encodeURIComponent(k.slug)}/edit`} className="btn btn-secondary konspekt-edit-link">
            Редактировать
          </Link>
        )}
      </div>
      <KonspektTiptapView docJson={doc} />
    </div>
  );
}
